import type { VFC } from "react";

const Footer: VFC = () => {
  return (
    <footer style={{ textAlign: "center", color: "gray", fontSize: "15px" }}>
      © 2021 RikuFujii(SuuCH),halpi(halpi17)
    </footer>
  );
};

export { Footer };
